import React from "react";

import { AppType } from "shared/utils/enums";
import { EmptyBehaviour } from "./EmptyBehaviour";
import { ConsoleBehaviour } from "./ConsoleBehaviour";
import { getEnvironmentInfo } from "shared/utils/config";
import { MyExperienceBehaviour } from "./MyExperienceBehaviour";

export default function ProgramHeaderBehaviourFactory() {
  const appType = getEnvironmentInfo().appType;
  switch (appType) {
    case AppType.CONSOLE:
      return new ConsoleBehaviour();
    case AppType.MYEXPERIENCE:
      return new MyExperienceBehaviour();
    default:
      return new EmptyBehaviour();
  }
}

export function useProgramHeaderBehaviourFactory() {
  return React.useMemo(() => ProgramHeaderBehaviourFactory(), []);
}
